<script>
export default {
    props: {
        typr: {
            type: String,  // Assuming it's a string, adjust if needed
        },
    },
    computed: {
        collectionClass() {
            return this.typr === 'collection' ? 'nav-link active' : 'nav-link';
        },
        invoiceClass() {
            return this.typr === 'invoice' ? 'nav-link active' : 'nav-link';
        },
        creditNoteClass() {
            return this.typr === 'creditnote' ? 'nav-link active' : 'nav-link';
        },
        soaClass() {
            return this.typr === 'soa' ? 'nav-link active' : 'nav-link';
        },
        agingReportClass() {
            return this.typr === 'agingreport' ? 'nav-link active' : 'nav-link';
        },
        paymentClass() {
            return this.typr === 'payment' ? 'nav-link active' : 'nav-link';
        },
        cardClass() {
            return this.typr === 'cards' ? 'nav-link active' : 'nav-link';
        },
    },
}
</script>

<template>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar'" :class="collectionClass">
            <i class="ri-information-line text-muted align-bottom me-1"></i>
            Collection Details
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/invoice'" :class="invoiceClass">
            <i class="ri-shopping-cart-2-line text-muted align-bottom me-1"></i>
            Invoices
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/creditnote'" :class="creditNoteClass">
            <i class="ri-file-edit-line text-muted align-bottom me-1"></i>
            Credit Notes
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/soa'" :class="soaClass">
            <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
            Statement of Account
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/agingreport'" :class="agingReportClass">
            <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
            Aging Report
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/payment'" :class="paymentClass">
            <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
            List Of Payment
        </router-link>
    </li>
    <li class="nav-item">
        <router-link :to="'/customer/customer-details/'+this.$route.params.id+'/ar/cards'" :class="cardClass">
            <i class="ri-checkbox-multiple-line text-muted align-bottom me-1"></i>
            Cards
        </router-link>
    </li>
</template>
